import { Address } from '../model/address.model';
import { GeocoderAddressComponent } from '../model/geocoder-address-component.model';

enum GeocoderAddressType {
  COUNTRY = 'country',
  POSTALCODE = 'postal_code',
  PROVINCE = 'administrative_area_level_2',
  CITY = 'administrative_area_level_3',
  POSTAL_TOWN = 'postal_town',
  LOCALITY = 'locality',
  STREET = 'route',
  STREETNUMBER = 'street_number',
}

export const mapAddressComponentToAddress = (addressComponent: GeocoderAddressComponent[]): Address => {
  return addressComponent.reduce(
    (acc, component) => {
      const types = component.types || [];
      const addressStreet = types.includes(GeocoderAddressType.STREET) ? component.longText : undefined;
      const addressStreetNumber = types.includes(GeocoderAddressType.STREETNUMBER)
        ? component.longText
        : undefined;
      const addressCity =
        types.includes(GeocoderAddressType.CITY) ||
        types.includes(GeocoderAddressType.POSTAL_TOWN) ||
        types.includes(GeocoderAddressType.LOCALITY)
          ? component.longText
          : undefined;
      const addressCountry = types.includes(GeocoderAddressType.COUNTRY) ? component.shortText : undefined;
      const addressPostalCode = types.includes(GeocoderAddressType.POSTALCODE)
        ? component.longText
        : undefined;

      return {
        ...acc,
        ...(addressStreet && { addressStreet }),
        ...(addressStreetNumber && { addressStreetNumber }),
        ...(addressCountry && { addressCountry }),
        ...(addressPostalCode && { addressPostalCode }),
        ...(addressCity && { addressCity }),
      };
    },
    {
      addressStreet: '',
      addressStreetNumber: '',
      addressCity: '',
      addressCountry: '',
      addressPostalCode: '',
    },
  );
};

export const formatAddressName = (address: Address | undefined): string => {
  if (!address) return '';

  const { addressStreet, addressStreetNumber, addressCity, addressPostalCode, addressCountry } = address;

  const street = [addressStreet, addressStreetNumber].filter(Boolean).join(' ');
  const cityAndPostal = addressCity ? (addressPostalCode ? `${addressCity} (${addressPostalCode})` : addressCity) : '';
  const country = addressCountry || '';

  return [street, cityAndPostal, country].filter(Boolean).join(', ');
};
